<template>
  <v-container fluid class="pa-0" id="speeddial">
    <div v-if="isLoadingInitialPageData">
      <v-progress-linear
        :active="isLoadingInitialPageData"
        :indeterminate="isLoadingInitialPageData"
        absolute
        top
        color="cyan"
      ></v-progress-linear>
    </div>
    <div v-if="!isLoadingInitialPageData">
      <ShiftsMenu />
      <v-progress-linear
        v-model="linearValue"
        :active="show"
        :indeterminate="query"
        :query="true"
        color="cyan"
      ></v-progress-linear>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        top
        color="cyan"
      ></v-progress-linear>
      <v-snackbar v-model="msg" top
        >{{ text }}
        <v-btn color="pink" text @click="msg = false"> Close</v-btn>
      </v-snackbar>
      <v-sheet height="64" class="mb-n3 mt-5">
        <v-toolbar flat>
          <div v-show="!$vuetify.breakpoint.smAndDown">
            <v-btn-toggle class="btn-group--active">
              <v-btn
                text
                outlined
                small
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="houseDialog = true"
                v-show="showProgramFilter"
              >
                <span color="white">Program</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>

            <v-btn-toggle class="btn-group--active ml-2">
              <v-btn
                text
                outlined
                small
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="staffDialog = true"
              >
                <span color="white">Staff</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>

            <v-btn-toggle class="btn-group--active ml-2">
              <v-btn
                text
                outlined
                small
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="clientDialog = true"
              >
                <span color="white">Client</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-btn-toggle class="btn-group--active ml-2">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-1"
                min-height="40"
                elevation="0"
                @click="clearSearchData()"
              >
                <span>Clear</span>
                <v-icon small color="black" class="ml-2"> mdi-close </v-icon>
              </v-btn>
            </v-btn-toggle>

            <p
              class="total-hours-schedule subtitle-1 d-inline-block mb-0"
              v-if="totalHoursSchedule > 0"
            >
              <v-icon>schedule</v-icon>
              <span>{{ totalHoursSchedule }}</span>
            </p>

            <v-dialog v-model="houseDialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Select Program</v-card-title>
                <v-divider></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchForHouses"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-card-text style="height: 300px">
                  <div v-for="house in resultQueryForHouses" :key="house._id">
                    <v-checkbox
                      v-model="houseSelected"
                      :label="house.Name"
                      :value="house._id"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="houseDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="houseFilterSelect()"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="staffDialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Select Staff</v-card-title>
                <v-divider></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchForStaff"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-card-text style="height: 300px">
                  <div v-for="employee in resultQuery" :key="employee._id">
                    <v-checkbox
                      v-model="staffSelected"
                      :label="employee.Name"
                      :value="employee._id"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="staffDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="staffFilterSelect()"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="clientDialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Select Client</v-card-title>
                <v-divider></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchForClient"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-card-text style="height: 300px">
                  <div v-for="client in resultQueryForClient" :key="client._id">
                    <v-checkbox
                      v-model="clientSelected"
                      :label="client.Name"
                      :value="client._id"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="clientDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="clientFilterSelect()"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!--
                        <v-btn-toggle class="btn-group--active ml-2" >
                          <v-btn
                            text
                            outlined
                            small
                            color="grey darken-4"
                            min-height="40"
                            elevation="0"
                            @click="totalTimeDialog = true"
                          >
                            <span color="white">View Total Time</span>
                            <v-icon small color="black" class="ml-2">
                              mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </v-btn-toggle>
                        -->
            <v-dialog v-model="totalTimeDialog" scrollable max-width="500px">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>View Total Time</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click="totalTimeDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text style="height: 300px">
                  <div v-for="employee in staff" :key="employee._id">
                    <!--
                                        <v-checkbox
                                          v-model="staffSelected"
                                          :label="employee.Name"
                                          :value="employee._id"
                                        ></v-checkbox>
                                        -->
                    <v-chip class="ma-2" color="pink" label text-color="white">
                      <v-icon left> mdi-av-timer </v-icon>
                      10 -
                      {{ employee.Name }}
                    </v-chip>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-spacer v-show="!$vuetify.breakpoint.smAndDown"></v-spacer>

          <!--                <v-btn-toggle relative>-->
          <!--                    <v-btn fab text small color="grey darken-4" @click="prev">-->
          <!--                        <v-icon small>-->
          <!--                            mdi-chevron-left-->
          <!--                        </v-icon>-->
          <!--                    </v-btn>-->
          <!--                    <v-btn-->
          <!--                        outlined-->
          <!--                        color=" darken-2"-->
          <!--                        small-->
          <!--                        @click="setToday"-->
          <!--                        min-height="40"-->
          <!--                    >-->
          <!--                        Today-->
          <!--                    </v-btn>-->
          <!--                    <v-btn outlined color="grey darken-4" small min-height="40">-->
          <!--                        <span v-if="$refs.calendar">-->
          <!--                            {{ $refs.calendar.title }}-->
          <!--                        </span>-->
          <!--                    </v-btn>-->
          <!--                    <v-btn fab text small color="grey darken-4" @click="next">-->
          <!--                        <v-icon small>-->
          <!--                            mdi-chevron-right-->
          <!--                        </v-icon>-->

          <!--                    </v-btn>-->
          <!--                </v-btn-toggle>-->

          <v-spacer></v-spacer>

          <div
            v-show="!$vuetify.breakpoint.smAndDown"
            class="mr-2"
            v-if="displayElemsOnStaff()"
          >
            <v-menu offset-y>
              <template
                v-slot:activator="{ on, attrs }"
                v-if="staffCanAccessOptions"
              >
                <v-btn-toggle>
                  <v-btn
                    outlined
                    color="grey darken-4"
                    min-height="40"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <span>Options</span>
                    <v-icon right> mdi-menu-down </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
              <v-list>
                <v-list-item @click="setCsvDialog(true)">
                  <v-list-item-title>Export CSV</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setBulkPublishDialog(true)">
                  <v-list-item-title>Bulk Publish</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setBulkDeleteDialog(true)">
                  <v-list-item-title>Bulk Delete</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setCopyScheduleDialog(true)">
                  <v-list-item-title>Copy Schedule</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setAddTimeClockDialog(true)">
                  <v-list-item-title>Add Time Clock</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <ShiftCSVDialog />
            <ShiftBulkPublish
              :houses="houses"
              @bulkPublish="bulkPublish($event)"
            />
            <ShiftBulkDelete
              :houses="houses"
              @bulkDelete="bulkDelete($event)"
            />
            <CopySchedule
              :clients="clients"
              :houses="houses"
              :calendarType="calendarType"
              :event-info="eventInfo"
              v-if="copyScheduleDialog"
              @copyShift="copyShift($event)"
            />
            <ManualAddDialog titleForm="View Missed Schedules" :staff="staff" />
          </div>

          <div
            v-show="!$vuetify.breakpoint.smAndDown"
            v-if="displayElemsOnStaff()"
          >
            <!--                    <v-menu bottom right>-->
            <!--                        <template v-slot:activator="{ on, attrs }">-->
            <!--                            <v-btn-toggle>-->
            <!--                                <v-btn-->
            <!--                                    outlined-->
            <!--                                    color="grey darken-4"-->
            <!--                                    min-height="40"-->
            <!--                                    v-bind="attrs"-->
            <!--                                    v-on="on"-->
            <!--                                    small-->
            <!--                                >-->
            <!--                                    <span>{{ typeToLabel[calendarType] }}</span>-->
            <!--                                    <v-icon right>-->
            <!--                                        mdi-menu-down-->
            <!--                                    </v-icon>-->
            <!--                                </v-btn>-->
            <!--                            </v-btn-toggle>-->
            <!--                        </template>-->
            <!--                        <v-list>-->
            <!--                            <v-list-item @click="setShiftCalendarType('day')">-->
            <!--                                <v-list-item-title>Day</v-list-item-title>-->
            <!--                            </v-list-item>-->
            <!--                            <v-list-item @click="setShiftCalendarType('week')">-->
            <!--                                <v-list-item-title>Week</v-list-item-title>-->
            <!--                            </v-list-item>-->
            <!--                            <v-list-item @click="setShiftCalendarType('month')">-->
            <!--                                <v-list-item-title>Month</v-list-item-title>-->
            <!--                            </v-list-item>-->
            <!--                            <v-list-item @click="setShiftCalendarType('4day')">-->
            <!--                                <v-list-item-title>4 days</v-list-item-title>-->
            <!--                            </v-list-item>-->
            <!--                        </v-list>-->
            <!--                    </v-menu>-->

            <v-dialog v-model="addDialog" width="">
              <template v-slot:activator="{ props }" v-if="staffCanAdd">
                <v-btn
                  dark
                  small
                  color="indigo darken-4"
                  min-height="40"
                  elevation="0"
                  class="ml-2"
                  v-bind="props"
                  @click="showAdd()"
                >
                  <v-icon small color="white"> mdi-plus </v-icon>
                  <span color="white">Add Shift</span>
                </v-btn>
              </template>

              <calendar-add-dialog
                :title-form="titleForm"
                :close="close"
                :staff="staff"
                :clients="clients"
                :houses="houses"
                @addSchedule="addSchedule($event)"
                @errorMessage="errorMessage"
                @successMessage="successMessage"
              />
            </v-dialog>
            <v-btn
              v-if="this.staffSelected.length > 0"
              dark
              small
              color="indigo darken-4"
              min-height="40"
              elevation="0"
              class="ml-2"
              @click="printCalendar()"
            >
              <v-icon small color="white"> mdi-printer </v-icon>
              <span color="white">Print</span>
            </v-btn>
          </div>

          <v-menu offset-y v-if="displayElemsOnStaff()">
            <template
              v-slot:activator="{ on, attrs }"
              v-if="staffCanAccessOptions"
            >
              <v-btn
                icon
                class="calendar--menu"
                v-show="$vuetify.breakpoint.smAndDown"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="setCsvDialog(true)">
                <v-list-item-title>Export CSV</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setBulkPublishDialog(true)">
                <v-list-item-title>Bulk Publish</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setBulkDeleteDialog(true)">
                <v-list-item-title>Bulk Delete</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setCopyScheduleDialog(true)">
                <v-list-item-title>Copy Schedule</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setAddTimeClockDialog(true)">
                <v-list-item-title>Add Time Clock</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-container class="py">
        <div class="d-flex justify-space-around">
          <v-switch
            class=""
            v-model="isPublish"
            :label="isPublish ? 'Published' : 'Unpublished'"
          ></v-switch>
          <v-tooltip bottom color="grey lighten-5">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mt-4"
                fab
                x-small
                elevation="1"
                color="warning darken-5"
                plain
                v-bind="attrs"
                v-on="on"
                @click.stop="unpublishNotifBtn = true"
              >
                <v-badge
                  dot
                  color="red darken-5"
                  v-if="unpublishNotifBadge > 0"
                >
                  <v-icon>event</v-icon>
                </v-badge>
                <v-icon v-if="unpublishNotifBadge === 0">event</v-icon>
              </v-btn>
              <v-dialog
                transition="dialog-top-transition"
                v-model="unpublishNotifBtn"
                max-width="960"
              >
                <v-card>
                  <v-app-bar dark color="red darken-5">
                    <v-app-bar-nav-icon></v-app-bar-nav-icon>

                    <v-toolbar-title
                      >Unpublished shifts in your programs this
                      week</v-toolbar-title
                    >
                  </v-app-bar>

                  <v-card-text>
                    <v-divider class="mb-3"></v-divider>
                    <v-simple-table fixed-header height="300px" class="mx-auto">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-center">Start</th>
                            <th class="text-center">End</th>
                            <th class="text-center">Program</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in unpublishList" :key="item.id">
                            <td>{{ item.name }}</td>
                            <td class="text-center">
                              {{ item.startDate }}
                              {{ item.timeStart12HourFormat }}
                            </td>
                            <td class="text-center">
                              {{ item.endDate }}
                              {{ item.timeEnd12HourFormat }}
                            </td>
                            <td class="text-center">
                              {{ item.programName }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="unpublishNotifBtn = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <span class="text--secondary"
              >Unpublished shifts you need to publish in your programs.</span
            >
          </v-tooltip>
          <v-tooltip bottom color="grey lighten-5">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mt-4"
                fab
                x-small
                elevation="1"
                color="warning darken-5"
                plain
                v-bind="attrs"
                v-on="on"
                @click.stop="unScheduledClients = true"
              >
                <v-badge dot color="red darken-5">
                  <v-icon>event_busy</v-icon>
                </v-badge>
              </v-btn>
              <v-dialog
                transition="dialog-top-transition"
                v-model="unScheduledClients"
                max-width="960"
              >
                <v-card>
                  <v-app-bar dark color="red darken-5">
                    <v-app-bar-nav-icon></v-app-bar-nav-icon>

                    <v-toolbar-title
                      >Unscheduled clients in your programs this date.
                    </v-toolbar-title>
                  </v-app-bar>

                  <v-card-text>
                    <v-divider class="mb-3"></v-divider>
                    <v-simple-table fixed-header height="300px" class="mx-auto">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-center">Program</th>
                            <th class="text-center">Staff Assigned</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="entry in staffAssignedToClients"
                            :key="entry.client._id"
                          >
                            <td>
                              {{ entry.client.Name }}
                            </td>
                            <td class="text-center">
                              {{ entry.client.Program.join(", ") }}
                            </td>
                            <td class="text-center">
                              {{
                                entry.user
                                  ? entry.user.Name
                                  : "No Staff Assigned"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="unScheduledClients = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <span class="text--secondary"
              >Unscheduled clients in your programs this date.</span
            >
          </v-tooltip>
        </div>
      </v-container>
      <v-sheet height="600" class="ma-4">
        <template>
          <div>
            <v-row>
              <v-col
                cols="12"
                sm="4"
                md="4"
                lg="3"
                class="order-2 order-md-1"
                :class="{ 'mb-4': isMobile }"
              >
                <v-card class="mx-auto pa-2 mb-1">
                  <v-card-text class="text-center">
                    <h4>
                      {{ selectedShiftStartDate }} -
                      {{ selectedShiftEndDate }}
                    </h4>
                  </v-card-text>
                </v-card>
                <v-spacer></v-spacer>
                <v-virtual-scroll
                  :items="consolidatedDurationHoursPerEmployee"
                  :item-height="virtualScrollItemHeight"
                  :height="virtualScrollCalculatedHeight"
                  class="overflow-x-hidden"
                >
                  <template v-slot:default="{ item }">
                    <v-card
                      :color="item.color"
                      class="mx-auto pa-1 mb-1"
                      max-width="344"
                      @click="getStaffShifts(item)"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-card-text
                            :class="dynamicCardNameColor(item.color)"
                            class=""
                          >
                            <div class="d-flex justify-center">
                              <v-avatar class="ma-1" color="white" size="34px">
                                <v-icon
                                  class="ma-auto"
                                  size="35"
                                  v-if="!item.image"
                                  >mdi-account-circle</v-icon
                                >
                                <v-img
                                  class="ma-auto"
                                  :src="item.image"
                                  v-else
                                ></v-img>
                              </v-avatar>
                              <span
                                class="font-weight-bold my-auto"
                                style="text-shadow: 2px 1px black"
                              >
                                {{ item.employeeName }}
                              </span>
                            </div>
                            <div>
                              <span
                                class="d-flex justify-center font-weight-bold my-auto"
                                style="text-shadow: 2px 1px black"
                              >
                                {{ item.duration.toFixed(2) }}
                                hour(s)
                              </span>
                            </div>
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card>
                  </template>
                </v-virtual-scroll>

                <v-dialog v-model="selectedStaffDialog">
                  <v-card>
                    <v-app-bar :color="selectedStaff.color">
                      <v-toolbar-title
                        >{{ selectedStaff.employeeName }}
                        shift(s) for this week
                      </v-toolbar-title>
                    </v-app-bar>
                    <v-divider class="mb-3"></v-divider>
                    <v-simple-table fixed-header height="300px" class="mx-auto">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Start</th>
                            <th class="text-left">End</th>
                            <th class="text-left">Clients</th>
                            <th class="text-left">Program</th>
                            <th class="text-center">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in selectedStaffShifts"
                            :key="index"
                          >
                            <td class="text-left">
                              {{ item.startDate }}
                              {{ item.timeStart12HourFormat }}
                            </td>
                            <td class="text-left">
                              {{ item.endDate }}
                              {{ item.timeEnd12HourFormat }}
                            </td>
                            <td class="text-left">
                              <div
                                v-for="(client, index) in item.clientName"
                                :key="index"
                              >
                                {{ client }}
                              </div>
                            </td>
                            <td class="text-left">
                              {{ item.programName }}
                            </td>
                            <td class="text-center">
                              {{
                                item.status == "1" ? "Published" : "Unpublished"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="9" class="order-1 order-md-2">
                <div>
                  <FullCalendar ref="fullCalendar" :options="calendarOptions">
                    <template #eventContent="{ event }">
                      <CustomEvent :event="event" />
                    </template>
                  </FullCalendar>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>

        <v-dialog v-model="selectedOpen">
          <calendar-update-dialog
            :title-form="titleForm"
            :close="close"
            :staff="staff"
            :clients="clients"
            :houses="houses"
            :event-data="selectedEvent"
            :updateClose="updateClose"
            :selectedOpen="selectedOpen"
            :isDisabledElemsOnStaff="displayElemsOnStaff()"
            @updateSchedule="updateSchedule($event)"
            @deleteSchedule="deleteSchedule($event)"
            @errorMessage="errorMessage"
          />
        </v-dialog>

        <!--                <v-menu-->
        <!--                    v-model="selectedOpen"-->
        <!--                    :close-on-content-click="false"-->
        <!--                    transition="scale-transition"-->
        <!--                    :activator="selectedElement"-->
        <!--                    content-class="calendar-update-dialog-v-menu-content"-->
        <!--                >-->
        <!--                    <calendar-update-dialog-->
        <!--                        :title-form="titleForm"-->
        <!--                        :close="close"-->
        <!--                        :staff="staff"-->
        <!--                        :clients="clients"-->
        <!--                        :houses="houses"-->
        <!--                        :event-data="selectedEvent"-->
        <!--                        :updateClose="updateClose"-->
        <!--                        :selectedOpen="selectedOpen"-->
        <!--                        @updateSchedule="updateSchedule($event)"-->
        <!--                        @deleteSchedule="deleteSchedule($event)"-->
        <!--                        @errorMessage="errorMessage"-->
        <!--                    />-->
        <!--                </v-menu>-->
      </v-sheet>

      <!--Start FullCalendar Drop Actions Dialog-->
      <v-dialog
        v-model="showCalendarEventDropActions"
        persistent
        max-width="290"
        v-if="displayElemsOnStaff()"
      >
        <v-card>
          <v-card-title class="text-h5"></v-card-title>
          <v-card-text>What would you like to do?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="copyCalendarEvent()"
              >Copy</v-btn
            >
            <v-btn color="green darken-1" text @click="moveCalendarEvent()"
              >Move</v-btn
            >
            <v-btn
              color="green darken-1"
              text
              @click="hideCalendarEventDropActions()"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--End FullCalendar Drop Actions Dialog-->
    </div>
  </v-container>
</template>

<script>
import CalendarAddDialog from "@/components/Calendar/addDialog.vue";
import CalendarUpdateDialog from "@/components/Calendar/updateDialog.vue";
import CustomEvent from "@/components/Calendar/CustomEvent";
import ShiftCSVDialog from "@/components/ShiftCSVDialog";
import ShiftBulkPublish from "@/components/ShiftBulkPublish";
import ShiftBulkDelete from "../components/ShiftBulkDelete.vue";
import CopySchedule from "@/components/CopySchedule";
import ManualAddDialog from "@/components/Timesheet/ManualAddDialog";
import ShiftsMenu from "@/components/Shifts/ShiftsMenu";
import DateTimeUtil from "../../utils/date-time.util.js";
import { datetime, RRule } from "rrule";

import moment from "moment";
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import Swal from "sweetalert2";
import { UserRole } from "@/constants/UserRole";
import moment_timezone from "moment-timezone";
import { displaySuccess } from "@/service/notification-message.service";

const url = require("../client_config/config").url;
const ShiftService = require("../service/shift.service");
const UnitService = require("../service/unit.service");

export default {
  components: {
    CalendarAddDialog,
    CalendarUpdateDialog,
    ShiftCSVDialog,
    ShiftBulkPublish,
    ShiftBulkDelete,
    CopySchedule,
    ManualAddDialog,
    ShiftsMenu,
    FullCalendar,
    CustomEvent,
  },

  data() {
    return {
      linearValue: 0,
      query: false,
      show: true,
      interval: 0,
      value: "",
      search: "",
      searchForStaff: null,
      searchForClient: null,
      searchForHouses: null,
      events: [],
      usersAllowedPermissionRoles: [],
      userRolesWithPrivilege: [],
      userRolesFilterProgram: [],
      staffFilterRoles: [],
      // colors: ["#2196F3", "#3F51B5", "#673AB7", "#00BCD4", "#4CAF50", "#FF9800", "#757575"],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      titleForm: "New Schedule",
      staff: [],
      clients: [],
      text: "",
      msg: "",
      color: "success",
      focus: "",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      selectedStart: new Date(),
      selectedEnd: new Date(
        new Date().setTime(new Date().getTime() + 8 * 60 * 60 * 1000)
      ),
      houseFilter: "",
      houses: [],
      //houseSelected: [],
      //staffSelected: [],
      //clientSelected: [],
      staffId: localStorage.getItem("staffId"),
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      totalTime: "",
      totalTimeDialog: false,
      visibleDateStart: null,
      visibleDateEnd: null,
      totalHoursSchedule: 0,
      calendarEvent: null,
      selectedShiftStartDate: "",
      selectedShiftEndDate: "",
      selectedTask: "",
      consolidatedDurationHoursPerEmployee: [],
      calendarEventDate: {},
      userRole: localStorage.getItem("userRole"),
      userPrograms: localStorage.getItem("userPrograms"),
      userProgramsList: [],
      userState: localStorage.getItem("userState"),
      loading: false,

      addShiftDialog: false,
      filteredByHouseList: [],
      isPublish: true,
      unpublishNotifBtn: false,
      unScheduledClients: false,
      unpublishNotifBadge: 0,
      unpublishList: [],
      unScheduledClientsList: [],
      staffAssignedToClients: [],
      shiftsList: [],
      selectedStaffDialog: false,
      selectedStaffShifts: [],
      selectedStaff: {},
      currentCalendarDateRange: "",
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridWeek",
        views: {
          dayGridFourDay: {
            type: "dayGrid",
            duration: {
              days: 4,
            },
          },
          dayGridTwoWeek: {
            // Add a new view 'dayGridTwoWeek'
            type: "dayGrid",
            duration: {
              weeks: 2,
            },
          },
        },
        customButtons: {
          customPrevious: {
            icon: "chevron-left",
            click: this.handlePreviousClick,
          },
          customToday: {
            text: "Today",
            click: this.handleTodayClick,
          },
          customNext: {
            icon: "chevron-right",
            click: this.handleNextClick,
          },
        },
        headerToolbar: {
          left: "customPrevious,customToday,customNext",
          center: "title",
          right:
            "dayGridFourDay,dayGridDay,dayGridWeek,dayGridTwoWeek,dayGridMonth,",
        },
        buttonText: {
          dayGridFourDay: "4 Days",
          dayGridDay: "Day",
          dayGridWeek: "Week",
          dayGridTwoWeek: "2 Weeks",
          dayGridMonth: "Month",
        },
        events: [],
        editable: true, // Enable drag-and-drop
        datesSet: this.handleDatesSet,
        eventClick: this.showFullCalendarEvent,
        eventDrop: this.handleEventDrop,
      },
      calendarEventDropInfo: null,
      showCalendarEventDropActions: false,
      eventInfo: null,
      virtualScrollItemHeight: 90,
      virtualScrollHeight: 500,
      virtualScrollCalculatedHeight: 0,
      userCompanyIds: localStorage.getItem("userCompanies")
        ? JSON.parse(localStorage.getItem("userCompanies"))
        : [],
      userCompanies: [], // Note: If the user role is SuperAdministrator, this will yield all the companies from the get companies API endpoint
      shiftStartDate: null,
      shiftEndDate: null,
      initialDataLoaded: false,
      dateSetInfo: null,
      isLoadingInitialPageData: false,
      staffCanAdd: true,
      staffCanAccessOptions: true,
      rolesToShowAllPrograms: [
        "SuperAdministrator",
        "Administration",
        "House Manager",
        "Program Manager",
        "Assistant Manager",
        "Human Resources",
        "Client Services Manager",
        "Program Coordinator",
        "Medical Manager",
        "Compliance Manager",
        "Support Coordinator",
      ],
    };
  },

  async created() {
    this.isLoadingInitialPageData = true;
    this.userProgramsList = this.userPrograms
      ? JSON.parse(this.userPrograms)
      : [];
    await this.getUserRolesPermission();
    await Promise.all([
      this.getStaff(),
      this.getClients(),
      this.getHouses(),
      this.getCompanies(),
    ]);
    this.initialDataLoaded = true;
    this.handleDatesSet(this.dateSetInfo);
    this.isLoadingInitialPageData = false;
    this.calendarOptions.editable = this.displayElemsOnStaff();

    if (
      this.userRole === "Shift Lead" ||
      this.userRole === "Direct Care Staff"
    ) {
      this.staffCanAdd = false;
      this.staffCanAccessOptions = false;
    }

    let shiftId = this.$route.query.view;

    if (shiftId) {
      ShiftService.getById(shiftId).then((response) => {
        const event = response.data;
        const formattedEvent = this.formatToNonRecurringCalendarEvent(event);
        const info = {
          event: {
            extendedProps: formattedEvent,
          },
        };
        this.showFullCalendarEvent(info);
      });
    }
  },

  computed: {
    ...mapState({
      calendarType: (state) => state.shifts.calendarType ?? "week",
      selectedShift: (state) => state.shifts.selectedShift,
      staffFilter: (state) => state.shifts.staffFilter,
      clientsFilter: (state) => state.shifts.clientsFilter,
      unitIdsFilter: (state) => state.shifts.unitIdsFilter,
      startDateFilter: (state) => state.shifts.startDateFilter,
      endDateFilter: (state) => state.shifts.endDateFilter,
      csvDialog: (state) => state.shifts.csvDialog,
      bulkPublishDialog: (state) => state.shifts.bulkPublishDialog,
      copyScheduleDialog: (state) => state.shifts.copyScheduleDialog,
      isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
      },
    }),

    houseSelected: {
      get() {
        return this.unitIdsFilter;
      },
      set(val) {
        this.setUnitIdsFilter(val);
      },
    },

    staffSelected: {
      get() {
        return this.staffFilter;
      },
      set(val) {
        this.setStaffFilter(val);
      },
    },

    clientSelected: {
      get() {
        return this.clientsFilter;
      },
      set(val) {
        this.setClientsFilter(val);
      },
    },

    /*
        sortedEvents() {
            const eventsCopy = [...this.events];
            return eventsCopy.sort((event1, event2) => {
                const time1 = this.getTimeInMinutes(event1.timeStart);
                const time2 = this.getTimeInMinutes(event2.timeStart);
                return time1 - time2;
            });
        },
        */
    showProgramFilter() {
      if (this.userRolesFilterProgram.includes(this.userRole)) {
        return true;
      }
      return false;
    },

    houseDialog: {
      get() {
        return this.$store.state.shifts.houseDialog;
      },
      set(val) {
        this.setHouseDialog(val);
      },
    },

    staffDialog: {
      get() {
        return this.$store.state.shifts.staffDialog;
      },
      set(val) {
        this.setStaffDialog(val);
      },
    },

    clientDialog: {
      get() {
        return this.$store.state.shifts.clientDialog;
      },
      set(val) {
        this.setClientDialog(val);
      },
    },

    addDialog: {
      get() {
        return this.$store.state.shifts.addShiftDialog;
      },
      set(val) {
        this.setAddShiftDialog(val);
      },
    },
    resultQuery() {
      if (this.searchForStaff) {
        return this.staff.filter((item) => {
          return this.searchForStaff
            .toLowerCase()
            .split(" ")
            .every((v) => item.Name.toLowerCase().includes(v));
        });
      } else {
        return this.staff;
      }
    },
    resultQueryForClient() {
      if (this.searchForClient) {
        return this.clients.filter((item) => {
          return this.searchForClient
            .toLowerCase()
            .split(" ")
            .every((v) => item.Name.toLowerCase().includes(v));
        });
      } else {
        return this.clients;
      }
    },
    resultQueryForHouses() {
      if (this.searchForHouses) {
        return this.filteredByHouseList.filter((item) => {
          return this.searchForHouses
            .toLowerCase()
            .split(" ")
            .every((v) => item.Name.toLowerCase().includes(v));
        });
      } else {
        return this.filteredByHouseList;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    async isPublish() {
      await this.getEvents(this.calendarEventDate);
    },

    selectedStaffDialog(val) {
      if (!val) {
        this.selectedStaffShifts = [];
        this.selectedStaff = {};
      }
    },

    addDialog(val) {
      if (!val) {
        this.setFormDialogIsOpen(val);
      }
    },
  },

  mounted() {
    this.queryAndIndeterminate();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    queryAndIndeterminate() {
      this.query = true;
      this.linearValue = 0;

      setTimeout(() => {
        this.query = false;

        this.interval = setInterval(() => {
          if (this.linearValue === 100) {
            clearInterval(this.interval);
            this.show = false;
            return setTimeout(this.queryAndIndeterminate, 1000);
          }
          this.linearValue += 25;
        }, 1000);
      }, 2000);
    },

    ...mapMutations("shifts", {
      setShiftCalendarType: "SET_SHIFT_CALENDAR_TYPE",
      setCsvDialog: "SET_CSV_DIALOG",
      setAddShiftDialog: "SET_ADD_SHIFT_DIALOG",
      setBulkPublishDialog: "SET_BULK_PUBLISH_DIALOG",
      setBulkDeleteDialog: "SET_BULK_DELETE_DIALOG",
      setCopyScheduleDialog: "SET_COPY_SCHEDULE_DIALOG",
      setStaffDialog: "SET_STAFF_DIALOG",
      setHouseDialog: "SET_HOUSE_DIALOG",
      setClientDialog: "SET_CLIENT_DIALOG",
      setFormDialogIsOpen: "SET_FORM_DIALOG_isOPEN",
      setSelectedShift: "SET_SELECTED_SHIFT",
      setClientsFilter: "SET_CLIENTS_FILTER",
      setStaffFilter: "SET_STAFF_FILTER",
      setUnitIdsFilter: "SET_UNITIDS_FILTER",
      setStartDateFilter: "SET_STARTDATE_FILTER",
      setEndDateFilter: "SET_ENDDATE_FILTER",
    }),

    ...mapActions("clients", ["getAllActiveClients"]),
    ...mapActions("users", ["fetchAllUsers"]),
    ...mapActions("units", ["getUnitList"]),

    ...mapMutations("timesheet", {
      setAddTimeClockDialog: "SET_SAVE_DIALOG",
      setTimeSheet: "SET_TIMESHEET",
    }),

    viewDay({ date }) {
      this.focus = date;
      this.setShiftCalendarType("day");
    },

    setToday() {
      this.focus = "";
    },

    prev() {
      this.$refs.calendar.prev();
      //console.log(this.$refs.calendar.getStartOfWeek());
      //this.previousFirstDayOfWeek();
      // console.log(this.$refs.calendar.getStartOfWeek());
    },

    next() {
      this.$refs.calendar.next();
    },

    handlePreviousClick() {
      this.$refs.fullCalendar.getApi().prev();
    },

    handleTodayClick() {
      this.$refs.fullCalendar.getApi().today();
    },

    handleNextClick() {
      this.$refs.fullCalendar.getApi().next();
    },

    handleDatesSet(info) {
      this.dateSetInfo = info;

      if (!this.initialDataLoaded || !info) {
        return;
      }

      const newCalendarDateRange = `${info.startStr}-${info.endStr}`;

      if (newCalendarDateRange === this.currentCalendarDateRange) {
        return;
      }

      switch (info.view.type) {
        case "dayGridFourDay":
          this.setShiftCalendarType("4day");
          break;
        case "dayGridDay":
          this.setShiftCalendarType("day");
          break;
        case "dayGridWeek":
          this.setShiftCalendarType("week");
          break;
        case "dayGridMonth":
          this.setShiftCalendarType("month");
          break;
        case "dayGridTwoWeek":
          this.setShiftCalendarType("2weeks");
          break;
      }

      this.currentCalendarDateRange = newCalendarDateRange;
      const eventInfo = {
        start: {
          date: moment(info.start).format("YYYY-MM-DD"),
        },
        end: {
          date: moment(info.end).subtract(1, "days").format("YYYY-MM-DD"),
        },
        title: info.view.title,
        type: info.view.type,
      };

      this.eventInfo = eventInfo;
      this.getEvents(eventInfo);
    },

    async handleEventDrop(info) {
      this.calendarEventDropInfo = info;
      this.showCalendarEventDropActions = true;
    },

    async copyCalendarEvent() {
      try {
        const { event: newEventApi } = this.calendarEventDropInfo;
        const { extendedProps: newEventProps } = newEventApi;
        const oldEventStartDate = new Date(newEventProps.utcStartDate);
        const oldEventEndDate = new Date(newEventProps.utcEndDate);
        const newEventStartDate = newEventApi.start;
        const newEventEndDate = newEventApi.end;

        // Set the original hours from the original shift start and end dates
        // This is because the newEventApi start and end is always giving 00:00:00 time
        newEventStartDate.setHours(
          oldEventStartDate.getHours(),
          oldEventStartDate.getMinutes(),
          oldEventStartDate.getSeconds(),
          oldEventStartDate.getMilliseconds()
        );
        newEventEndDate.setHours(
          oldEventEndDate.getHours(),
          oldEventEndDate.getMinutes(),
          oldEventEndDate.getSeconds(),
          oldEventEndDate.getMilliseconds()
        );

        const payload = {
          shiftId: newEventProps.shiftId,
          startDate: DateTimeUtil.toUTCISOString(newEventStartDate),
          endDate: DateTimeUtil.toUTCISOString(newEventEndDate),
        };

        await ShiftService.copy(payload).then(() => {
          this.getEvents(this.calendarEventDate);
        });

        this.hideCalendarEventDropActions();
        Swal.fire({
          title: "Success!",
          text: "Shift copied successfully. Please check on unpublished shift.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: true,
          allowEscapeKey: true,
        });
      } catch (error) {
        this.hideCalendarEventDropActions();
        Swal.fire({
          title: "Error",
          text: error.response.data.error,
          icon: "error",
          allowOutsideClick: true,
          allowEscapeKey: true,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Close",
        });
      }
    },

    async moveCalendarEvent() {
      try {
        const { event: newEventApi } = this.calendarEventDropInfo;
        const { extendedProps: newEventProps } = newEventApi;
        const oldEventStartDate = new Date(newEventProps.utcStartDate);
        const oldEventEndDate = new Date(newEventProps.utcEndDate);
        const newEventStartDate = newEventApi.start;
        const newEventEndDate = newEventApi.end;

        // Set the original hours from the original shift start and end dates
        // This is because the newEventApi start and end is always giving 00:00:00 time
        newEventStartDate.setHours(
          oldEventStartDate.getHours(),
          oldEventStartDate.getMinutes(),
          oldEventStartDate.getSeconds(),
          oldEventStartDate.getMilliseconds()
        );
        newEventEndDate.setHours(
          oldEventEndDate.getHours(),
          oldEventEndDate.getMinutes(),
          oldEventEndDate.getSeconds(),
          oldEventEndDate.getMilliseconds()
        );

        const payload = {
          shiftId: newEventProps.shiftId,
          startDate: DateTimeUtil.toUTCISOString(newEventStartDate),
          endDate: DateTimeUtil.toUTCISOString(newEventEndDate),
          tz: moment_timezone.tz.guess(),
        };

        await ShiftService.move(payload).then(() => {
          this.getEvents(this.calendarEventDate);
          // this.calendarOptions.events.push(
          //     this.formatToNonRecurringCalendarEvent(response.data)
          // );
        });

        this.hideCalendarEventDropActions();
      } catch (error) {
        this.hideCalendarEventDropActions();
        this.text = error.response.data.error;
        this.msg = true;
      }
    },

    hideCalendarEventDropActions() {
      this.calendarEventDropInfo.revert();
      this.calendarEventDropInfo = null;
      this.showCalendarEventDropActions = false;
    },

    showAdd() {
      /*
            this.addDialog = true;
            this.setAddShiftDialog(true)
            this.titleForm = "New Shift";
            this.setFormDialogIsOpen(this.addDialog)
            */
      this.$router.push({
        path: `/shifts/add-shift`,
        query: { newUser: "true" },
      });
    },

    close() {
      this.addDialog = false;
      this.setFormDialogIsOpen(this.addDialog);
    },

    updateClose() {
      this.selectedOpen = false;
      this.setFormDialogIsOpen(this.selectedOpen);
    },

    async getStaff() {
      this.userRole = this.userRole || "";

      if (this.staffFilterRoles.includes(this.userRole)) {
        await axios
          .get(`${url}/employees/staff/${this.userState}`)
          .then((res) => {
            this.staff = res.data.employees;
          });
      } else {
        await axios
          .get(
            `${url}/employees/staff/${
              this.userState
            }?program=${this.userProgramsList.toString()}`
          )
          .then((res) => {
            this.staff = res.data.employees;
          });
      }
      // staff filter drop down needs to be only active staff and the same thing with the client filter . . .
    },

    async getClients() {
      let params = {};
      let endpoint = `${url}/clients`;
      params["Company:in"] = this.userCompanyIds;
      params["Status"] = "Active";

      if (
        this.userRole !== "Administration" &&
        this.userRole !== "SuperAdministrator"
      ) {
        params["State"] = this.userState;
      }

      try {
        const response = await axios.get(endpoint, { params });
        response.data.clients.forEach((item) => {
          this.clients.push(item);
        });
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    },

    async getHouses() {
      await axios
        .get(`${url}/units/state/${this.userState}`)
        .then((response) => {
          response.data.units.forEach((item) => {
            this.houses.push(item);
          });
        });

      if (
        this.userRolesWithPrivilege.includes(this.userRole) ||
        this.userRole === "SuperAdministrator"
      ) {
        console.log({ houses: this.houses });
        this.filteredByHouseList = this.houses;
      } else {
        this.userProgramsList.forEach((program) => {
          this.houses.forEach((house) => {
            if (program === house.Name) {
              if (this.filteredByHouseList.includes(house) === false) {
                this.filteredByHouseList.push(house);
              }
            }
          });
        });
      }
    },

    async getCompanies() {
      await axios.get(`${url}/companies`).then((res) => {
        const companies = res.data.companies;
        this.userCompanies = companies;

        if (this.userRole !== UserRole.SUPER_ADMINISTRATOR) {
          this.userCompanies = companies.filter((company) =>
            this.userCompanyIds.includes(company._id)
          );
        }
      });
    },

    async getEvents(event) {
      this.calendarEventDate = event;
      this.events = [];
      this.loading = true;
      this.totalHoursSchedule = 0;

      let {
        start: { date: startDate },
        end: { date: endDate },
      } = event || {};

      this.selectedShiftStartDate = startDate;
      this.selectedShiftEndDate = endDate;

      startDate = DateTimeUtil.toUTCISOString(
        DateTimeUtil.toStartOfDay(startDate)
      );
      endDate = DateTimeUtil.toUTCISOString(DateTimeUtil.toEndOfDay(endDate));

      //THIS CODE WORKS WHEN USER UPDATE A SHIFT
      if (
        this.selectedShift &&
        Object.keys(this.selectedShift).length > 0 &&
        this.selectedShift.startCalendarShift
      ) {
        this.$refs.fullCalendar
          .getApi()
          .gotoDate(this.selectedShift.startCalendarShift);
        this.setStartDateFilter(this.selectedShift.startCalendarShift);
        this.setEndDateFilter(this.selectedShift.endCalendarShift);

        this.shiftStartDate = this.selectedShift.startCalendarShift;
        this.shiftEndDate = this.selectedShift.endCalendarShift;

        if (startDate !== this.selectedShift.startCalendarShift) {
          return;
        }

        this.setSelectedShift([]);
      } else {
        this.setStartDateFilter(startDate);
        this.setEndDateFilter(endDate);

        this.shiftStartDate = startDate;
        this.shiftEndDate = endDate;
      }

      this.consolidatedDurationHoursPerEmployee = [];

      let unitIds = "";
      let staffIds = "";

      if (this.showProgramFilter) {
        unitIds =
          this.unitIdsFilter && this.unitIdsFilter.length > 0
            ? this.unitIdsFilter.toString()
            : "ALL";
        staffIds =
          this.staffFilter && this.staffFilter.length > 0
            ? this.staffFilter.toString()
            : "ALL";
      } else {
        await UnitService.getIdsByNames(this.userProgramsList, this.userState)
          .then((response) => {
            unitIds = response.data.toString();
            staffIds =
              this.staffFilter && this.staffFilter.length > 0
                ? this.staffFilter.toString()
                : "ALL";
          })
          .catch((e) => {
            console.log({ error: e.response.data.message });
            unitIds = "";
          });
      }

      let clients =
        this.clientsFilter && this.clientsFilter.length > 0
          ? this.clientsFilter.toString()
          : "ALL";

      const params = {
        startDate: this.startDateFilter,
        endDate: this.endDateFilter,
        unitIds,
        staffIds,
        clients,
        userState: this.userState,
        // Company: this.userCompanyIds,
        includeExtendedShifts: true,
      };

      if (
        this.userRole === "Administration" ||
        this.userRole === "SuperAdministrator"
      ) {
        delete params.userState;
      } else {
        params.userState = this.userState;
      }
      let events = [];

      await ShiftService.get(params)
        .then((response) => {
          response.data.shifts.forEach((item) => {
            if (
              this.userRole === "Administration" ||
              this.userRole === "SuperAdministrator"
            ) {
              if (item.isRecurringEvent === "Yes") {
                events = events.concat(
                  this.formatToRecurringCalendarEvent(item, startDate, endDate)
                );
              } else {
                events.push(this.formatToNonRecurringCalendarEvent(item));
              }
            } else {
              if (item.EmployeeState === this.userState) {
                if (item.isRecurringEvent === "Yes") {
                  events = events.concat(
                    this.formatToRecurringCalendarEvent(
                      item,
                      startDate,
                      endDate
                    )
                  );
                } else {
                  events.push(this.formatToNonRecurringCalendarEvent(item));
                }
              }
            }
          });
        })
        .catch((e) => {
          console.log(e);
          //this.msg = true;
          //this.text = e.response.data.msg;
          //this.color = 'red';
        })
        .finally(async () => {
          this.loading = false;
          this.calendarEvent = event;
          this.shiftsList = events;
          this.getHoursPerSchedule(this.calendarType, event);

          const groupedEvents = await this.groupEventsByProgram(events);
          const filteredEvents = await this.filterPublishedEvents(
            groupedEvents
          );

          this.updateCalendarOptions(filteredEvents);
          this.filterConsolidatedDurationHoursPerEmployee();
          await this.getUnscheduledClients(filteredEvents, this.houseSelected);
        });
    },

    formatToRecurringCalendarEvent(item, startDate, endDate) {
      let StartDate = item.StartDate;
      let EndDate = item.EndDate;

      const color =
        item.ShiftColor || this.colors[this.rnd(0, this.colors.length - 1)];
      const shiftStartDateTime = moment(item.StartDate).format(
        "YYYY-MM-DD HH:mm"
      );
      const shiftEndDateTime = moment(item.EndDate).format("YYYY-MM-DD HH:mm");
      const shiftStartTime = moment(item.StartDate).format("HH:mm");
      const shiftEndTime = moment(item.EndDate).format("HH:mm");
      const shiftStartTime12HourFormat = moment(item.StartDate).format("h:mmA");
      const shiftEndTime12HourFormat = moment(item.EndDate).format("h:mmA");

      // USED FOR STAFF DURATION CALCULATION
      if (startDate > StartDate) {
        StartDate = startDate;
      }

      if (endDate < EndDate) {
        EndDate = endDate;
      }

      const recurringYear = moment(StartDate).utc().year();
      const recurringMonth = moment(StartDate).utc().format("M");
      const recurringDay = moment(StartDate).utc().format("D");
      const recurringHour = moment(StartDate).utc().format("HH");
      const recurringMinute = moment(StartDate).utc().format("mm");

      const recurringEndYear = moment(EndDate).utc().year();
      const recurringEndMonth = moment(EndDate).utc().format("M");
      const recurringEndDay = moment(EndDate).utc().format("D");
      const recurringEndHour = moment(EndDate).utc().format("HH");
      const recurringEndMinute = moment(EndDate).utc().format("mm");

      const recurringTypeSwitch = (eventType) =>
        ({
          Daily: RRule.DAILY,
          Weekly: RRule.WEEKLY,
          Monthly: RRule.MONTHLY,
          Annually: RRule.YEARLY,
        }[eventType]);

      const recurringDate = new RRule({
        freq: recurringTypeSwitch(item.typeOfRecurringEvent),
        dtstart: datetime(
          parseInt(recurringYear),
          parseInt(recurringMonth),
          parseInt(recurringDay),
          parseInt(recurringHour),
          parseInt(recurringMinute)
        ),
        until: datetime(
          parseInt(recurringEndYear),
          parseInt(recurringEndMonth),
          parseInt(recurringEndDay),
          parseInt(recurringEndHour),
          parseInt(recurringEndMinute)
        ),
        interval: 1,
      });

      const dateRec = recurringDate
        .all()
        .map((date) => moment(date).format("YYYY-MM-DD"));
      let events = [];

      dateRec.forEach((itemDate) => {
        let date = itemDate;
        itemDate = moment(
          date + " " + shiftStartTime,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");

        if (shiftEndTime < shiftStartTime) {
          date = moment(date).add(1, "days").format("YYYY-MM-DD");
        }

        let endDate = moment(
          date + " " + shiftEndTime,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");
        const difference = moment(endDate).diff(moment(itemDate));
        const duration = moment.duration(difference);
        //const durationAsHours = duration.asHours();

        const durationAsHours =
          this.getBusinessHoursWithSaturdayAndSundaySeparate(
            shiftStartDateTime,
            shiftEndDateTime,
            this.selectedShiftStartDate,
            this.selectedShiftEndDate
          );

        const start = moment(itemDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");

        const employeeName = item.EmployeeName || "N/A";
        const houseAddress = item.unitsInfo.Address ?? "";
        const title = `<div>${shiftStartTime12HourFormat}: </div>${employeeName}: ${item.ClientName}: ${houseAddress}`;
        const clientNameText = `${item.ClientName}`;

        this.composeConsolidatedDurationHoursPerEmployee(
          item,
          durationAsHours,
          color
        );

        let toPushEvents = {
          id: item._id, // FullCalendar specific field to show the calendar event
          title: title, // FullCalendar specific field to show the calendar event
          start: start, // FullCalendar specific field to show the calendar event
          end: end, // FullCalendar specific field to show the calendar event
          shiftId: item._id,
          startDate: moment(StartDate).format("YYYY-MM-DD"), // Displayed start date in unpublished shifts notification
          endDate: moment(EndDate).format("YYYY-MM-DD"), // Displayed end date in unpublished shifts notification
          utcStartDate: item.StartDate, // Used in the calendar extended props - for data processing only
          utcEndDate: item.EndDate, // Used in the calendar extended props - for data processing only
          startShift: shiftStartDateTime,
          endShift: shiftEndDateTime,
          timeStart: shiftStartTime,
          timeEnd: shiftEndTime,
          timeStart12HourFormat: shiftStartTime12HourFormat,
          timeEnd12HourFormat: shiftEndTime12HourFormat,
          color: color,
          event: "Schedule",
          name: item.EmployeeName,
          notes: item.Notes,
          staffId: item.employee,
          clientId: item.ClientId,
          clientName: item.ClientName,
          clientNameText: clientNameText,
          houseId: item.HouseId,
          programName: item.unitsName,
          unitsLocation: item.unitsLocation,
          status: item.Status,
          duration: duration.asHours(),
          task: item.Task,
          isForTraining: item.isTraining,
          isRecurringEvent: item.isRecurringEvent,
          selectedOption: item.typeOfRecurringEvent,
          startDateOfRecurringEvent: item.startDateOfRecurringEvent,
          endDateOfRecurringEvent: item.endDateOfRecurringEvent,
          UpdatedDate: item.UpdatedDate,
          UpdatedByUser: item.UpdatedByUser,
          UpdateLogs: item.UpdateLogs,
          // Helper properties below
          published: item.Status === "1",
          recurring: item.isRecurringEvent === "Yes",
          training: item.isTraining === "Yes",
          // serviceCode: item.ServiceCode,
        };

        if (item.ClientServiceCode !== undefined)
          toPushEvents.ClientServiceCode = item.ClientServiceCode;
        else if (item.ServiceCode !== undefined)
          toPushEvents.serviceCode = item.ServiceCode;

        events.push(toPushEvents);
      });

      return events;
    },

    formatToNonRecurringCalendarEvent(item) {
      let StartDate = moment(item.StartDate).format("YYYY-MM-DD");
      let EndDate = moment(item.EndDate).format("YYYY-MM-DD");

      const color =
        item.ShiftColor || this.colors[this.rnd(0, this.colors.length - 1)];
      const shiftStartDateTime = moment(item.StartDate).format(
        "YYYY-MM-DD HH:mm"
      );
      const shiftEndDateTime = moment(item.EndDate).format("YYYY-MM-DD HH:mm");
      const shiftStartTime = moment(item.StartDate).format("HH:mm");
      const shiftEndTime = moment(item.EndDate).format("HH:mm");
      const shiftStartTime12HourFormat = moment(item.StartDate).format("h:mmA");
      const shiftEndTime12HourFormat = moment(item.EndDate).format("h:mmA");
      /*const difference = moment(shiftEndDateTime).diff(
        moment(shiftStartDateTime)
      );
      */
      //const duration = moment.duration(difference);
      const duration = this.getBusinessHoursWithSaturdayAndSundaySeparate(
        shiftStartDateTime,
        shiftEndDateTime,
        this.selectedShiftStartDate,
        this.selectedShiftEndDate
      );

      const employeeName = item.EmployeeName || "N/A";
      const houseAddress = item.unitsInfo?.Address ?? "";
      const title = `${shiftStartTime12HourFormat}: ${employeeName}: ${item.ClientName}: ${houseAddress}`;
      const clientNameText = `${item.ClientName}`;
      /*
      let durationRounded =
        Math.round((duration.asHours() + Number.EPSILON) * 100) / 100;
      */
      this.composeConsolidatedDurationHoursPerEmployee(item, duration, color);

      // if (StartDate === "2024-09-08") console.log({item});

      let returnItem = {
        id: item._id, // FullCalendar specific field to show the calendar event
        title: title, // FullCalendar specific field to show the calendar event
        start: shiftStartDateTime, // FullCalendar specific field to show the calendar event
        end: shiftEndDateTime, // FullCalendar specific field to show the calendar event
        shiftId: item._id,
        startDate: StartDate, // Displayed start date in unpublished shifts notification
        endDate: EndDate, // Displayed end date in unpublished shifts notification
        utcStartDate: item.StartDate, // Used in the calendar extended props - for data processing only
        utcEndDate: item.EndDate, // Used in the calendar extended props - for data processing only
        startShift: shiftStartDateTime,
        endShift: shiftEndDateTime,
        timeStart: shiftStartTime,
        timeEnd: shiftEndTime,
        timeStart12HourFormat: shiftStartTime12HourFormat,
        timeEnd12HourFormat: shiftEndTime12HourFormat,
        color: color,
        event: "Schedule",
        name: item.EmployeeName,
        notes: item.Notes,
        staffId: item.employee,
        clientId: item.ClientId,
        clientName: item.ClientName,
        clientNameText: clientNameText,
        houseId: item.HouseId,
        programName: item.unitsName,
        unitsLocation: item.unitsLocation,
        status: item.Status,
        duration: duration,
        task: item.Task,
        isForTraining: item.isTraining,
        isRecurringEvent: item.isRecurringEvent,
        selectedOption: item.typeOfRecurringEvent,
        startDateOfRecurringEvent: item.startDateOfRecurringEvent,
        endDateOfRecurringEvent: item.endDateOfRecurringEvent,
        UpdatedDate: item.UpdatedDate,
        UpdatedByUser: item.UpdatedByUser,
        UpdateLogs: item.UpdateLogs,
        // Helper properties below
        published: item.Status === "1",
        recurring: item.isRecurringEvent === "Yes",
        training: item.isTraining === "Yes",
        // serviceCode: item.ServiceCode,
        requiresSupervision: !!item.RequiresSupervision,
      };

      if (
        item.ClientServiceCode !== undefined &&
        item.ClientServiceCode.length > 0
      )
        returnItem.ClientServiceCode = item.ClientServiceCode;
      else if (item.ServiceCode !== undefined)
        returnItem.serviceCode = item.ServiceCode;

      return returnItem;
    },

    getBusinessHoursWithSaturdayAndSundaySeparate(
      startTime,
      endTime,
      selectedStartCalendarShift,
      selectedEndCalendarShift
    ) {
      let start = moment(startTime);
      let end = moment(endTime);
      let startCalendar = moment(selectedStartCalendarShift);
      let endCalendar = moment(selectedEndCalendarShift);

      let dayOfStartWeek = start.isoWeekday(); // Monday (1) - Sunday (7)
      let dayOfEndWeek = end.isoWeekday();

      if (
        dayOfStartWeek === 6 &&
        start.isSame(endCalendar, "day") &&
        !end.isSame(endCalendar, "day")
      ) {
        let dayEnd = start.clone().endOf("day");
        if (dayEnd.isAfter(end)) {
          dayEnd = end;
        }
        return moment.duration(dayEnd.diff(start)).asHours();
      } else if (
        dayOfEndWeek === 7 &&
        end.isSame(startCalendar, "day") &&
        !start.isSame(startCalendar, "day")
      ) {
        const startMidnight = moment(end).startOf("day");
        return moment.duration(end.diff(startMidnight)).asHours();
      } else {
        return moment.duration(end.diff(start)).asHours();
      }
    },

    getBusinessHoursExcludingSunday(startTime, endTime) {
      let start = moment(startTime);
      let end = moment(endTime);
      let totalHours = 0;

      if (start.isoWeekday() !== 7) {
        // Exclude Sundays (isoWeekday 7)
        let nextCheckpoint = start.clone().endOf("day");
        if (nextCheckpoint.isAfter(end)) {
          nextCheckpoint = end;
        }
        totalHours += moment.duration(nextCheckpoint.diff(start)).asHours();
      }

      return Math.round((totalHours + Number.EPSILON) * 100) / 100;
    },

    composeConsolidatedDurationHoursPerEmployee(item, durationAsHours, color) {
      //console.log("consolidated", item);
      // const itemHouseCompanyIds = item.unitsInfo.Company;
      // const commonCompanies = this.userCompanyIds.filter(companyId => itemHouseCompanyIds.includes(companyId));

      // if (commonCompanies.length) {
      const unitPerEmployee = {
        employeeId: item.employee,
        employeeName: item.EmployeeName,
        duration: parseFloat(durationAsHours.toFixed(2)),
        color: color,
        image: item.EmployeeImage || "",
        publishStatus: item.Status,
        clients: item.ClientName,
        location: item.unitsLocation,
        // Helper properties below
        published: item.Status === "1",
        recurring: item.isRecurringEvent === "Yes",
        training: item.isTraining === "Yes",
      };

      const existingEmployee = this.consolidatedDurationHoursPerEmployee.find(
        (emp) =>
          emp.employeeId === unitPerEmployee.employeeId &&
          emp.publishStatus === unitPerEmployee.publishStatus
      );

      if (existingEmployee) {
        existingEmployee.duration += unitPerEmployee.duration;
      } else {
        this.consolidatedDurationHoursPerEmployee.push(unitPerEmployee);
      }
      // Below is the dynamic setting of the VVirtualScroll height
      // Calculate the total height of all items
      let totalHeight =
        this.consolidatedDurationHoursPerEmployee.length *
        this.virtualScrollItemHeight;
      // Limit the height
      this.virtualScrollCalculatedHeight =
        Math.min(totalHeight, this.virtualScrollHeight) + "px";
      // }
    },

    async groupEventsByProgram(events) {
      const groupedEvents = [];
      let houseProgramIds = [];
      this.filteredByHouseList.forEach((program) => {
        houseProgramIds.push(program._id);
        const programEvents = events.filter(
          (event) => event.houseId === program._id
        );
        groupedEvents.push(...programEvents);
      });

      return groupedEvents;
    },

    async filterPublishedEvents(events) {
      this.getUnpublishedShift(events);

      if (this.isPublish) {
        return events.filter((event) => event.status === "1");
      } else {
        return events.filter((event) => event.status === "0");
      }
    },

    updateCalendarOptions(events) {
      this.events = events;
      this.calendarOptions.events = this.events;
      this.calendarOptions.eventOrder = ["houseId", "timeStart"];
    },

    filterConsolidatedDurationHoursPerEmployee() {
      if (this.isPublish) {
        this.consolidatedDurationHoursPerEmployee =
          this.consolidatedDurationHoursPerEmployee.filter(
            (employee) => employee.publishStatus === "1"
          );
      } else {
        this.consolidatedDurationHoursPerEmployee =
          this.consolidatedDurationHoursPerEmployee.filter(
            (employee) => employee.publishStatus === "0"
          );
      }
    },

    // get unpublished shifts for managers notification
    getUnpublishedShift(events) {
      events = events.filter((event) => {
        if (event.status === "0") {
          return event;
        }
      });

      this.unpublishNotifBadge = events.length;
      this.unpublishList = events;
    },

    async getUnscheduledClients(filteredEvents, houseIds) {
      this.staffAssignedToClients = [];
      let unitList = [];

      const userState = this.userState;
      const clients = await this.getAllActiveClients(userState);
      const users = await this.fetchAllUsers();

      const eventsClientIds = filteredEvents.map((event) => event.clientId);
      const flattenedEventsClientIds = eventsClientIds.flat();

      this.unScheduledClientsList = clients.filter(
        (client) => !flattenedEventsClientIds.includes(client._id)
      );

      const userMapByClientId = {};
      users.forEach((user) => {
        userMapByClientId[user.ClientID] = user;
      });

      if (houseIds.length > 0) {
        unitList = await this.getUnitList(houseIds);

        this.unScheduledClientsList.forEach((client) => {
          for (let unit of unitList) {
            if (client.Program.includes(unit.Name)) {
              this.staffAssignedToClients.push({
                client: client,
                user: userMapByClientId[client._id],
              });
              break;
            }
          }
        });
      } else {
        this.staffAssignedToClients = this.unScheduledClientsList.map(
          (client) => {
            return {
              client: client,
              user: userMapByClientId[client._id],
            };
          }
        );
      }
    },

    // Get staff's shifts when user click the card on the left side.
    getStaffShifts(item) {
      this.selectedStaffDialog = true;
      this.selectedStaff = item;

      this.shiftsList.forEach((shift) => {
        if (shift.staffId === this.selectedStaff.employeeId)
          this.selectedStaffShifts.push(shift);
      });
    },

    dynamicCardNameColor(color) {
      return color === "#FFFFFF" ? "black--text" : "white--text";
    },

    /*
        getTimeInMinutes(timeString) {
         const [hours, minutes] = timeString.split(':');
         let totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
         if (timeString.includes('pm') && parseInt(hours) !== 12) {
            totalMinutes += 12 * 60;
         }
         return totalMinutes;
        },
        */

    getHoursPerSchedule(calendarType, eventInfo) {
      // For v-calendar. Disabled because we are now using fullcalendar
      // let isMonth = 0;
      //
      // switch (this.calendarType) {
      //     case 'month':
      //         this.visibleDateStart = this.$refs.calendar.getStartOfWeek(event.start);
      //         this.visibleDateEnd = this.$refs.calendar.getEndOfWeek(event.end);
      //         isMonth = 1;
      //         break;
      //     default:
      //         this.visibleDateStart = this.$refs.calendar._data.lastStart.date;
      //         this.visibleDateEnd = this.$refs.calendar._data.lastEnd.date;
      //         break;
      // }
      //
      // this.events.forEach(event => {
      //     if (event.start && event.end) {
      //         if (isMonth) {
      //             this.getEventDateValidity(event.start, event.end, this.visibleDateStart.date, this.visibleDateEnd.date);
      //         } else {
      //             this.getEventDateValidity(event.start, event.end, this.visibleDateStart, this.visibleDateEnd);
      //         }
      //     }
      // });

      // For fullcalendar

      this.events.forEach((event) => {
        if (event.start && event.end) {
          this.getEventDateValidity(
            event.start,
            event.end,
            eventInfo.start.date,
            eventInfo.end.date
          );
        }
      });
    },

    getEventDateValidity(eventStartDate, eventEndDate, vdStart, vdEnd) {
      let startDate = moment(eventStartDate, "YYYY-MM-DD"),
        endDate = moment(eventEndDate, "YYYY-MM-DD");

      if (
        startDate.isBetween(vdStart, vdEnd, undefined, "[]") &&
        endDate.isBetween(vdStart, vdEnd, undefined, "[]")
      ) {
        let totalHours = moment.duration(
          moment(eventEndDate).diff(moment(eventStartDate))
        );

        this.totalHoursSchedule += parseInt(totalHours.asHours().toFixed(2));
      }
    },

    getEventColor(event) {
      return event.color;
    },

    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.setSelectedShift = event;
        //console.log(event);
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        this.selectedStart = new Date(event.start);
        this.selectedEnd = new Date(event.end);
        this.selectedTask = event.Task;
        //this.scheduleID = event.id;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.setFormDialogIsOpen(true);
            return (this.selectedOpen = true);
          })
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },

    showFullCalendarEvent(info) {
      const event = info.event.extendedProps;
      const newEvent = {
        ...event,
        startCalendarShift: this.startDateFilter,
        endCalendarShift: this.endDateFilter,
      };
      this.setSelectedShift(newEvent);
      this.$router.push({ path: `/shifts/update-shift` });
      /*
                const open = () => {
                    this.selectedEvent = event;
                    this.setSelectedShift(event);
                    this.selectedStart = new Date(event.start);
                    this.selectedEnd = new Date(event.end);
                    this.selectedTask = event.Task;
                    requestAnimationFrame(() => requestAnimationFrame(() => {
                        this.setFormDialogIsOpen(true)
                        return this.selectedOpen = true
                    }))
                };

                if (this.selectedOpen) {
                    this.selectedOpen = false;
                    requestAnimationFrame(() => requestAnimationFrame(() => open()))
                } else {
                    open();
                }
            */
    },

    bulkPublish(data) {
      console.log({ dataPublish: data });
      displaySuccess(data.msg);
    },

    bulkDelete(data) {
      this.getEvents(this.calendarEventDate);
      Swal.fire({
        title: data.color,
        text: data.text,
        icon: data.color,
        allowOutsideClick: true,
        allowEscapeKey: true,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: "Close",
      });
    },

    copyShift(data) {
      console.log({ copyShift: data });
      this.getEvents(this.calendarEventDate);
      displaySuccess("Shift/s copied successfully, make sure to publish it.");
    },

    addSchedule(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.addDialog = data.addDialog;

      this.getEvents(this.calendarEventDate);
    },

    errorMessage(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
    },

    successMessage(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
    },

    async updateSchedule(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.selectedOpen = data.selectedOpen;

      this.getEvents(this.calendarEventDate);
    },

    deleteSchedule(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.selectedOpen = data.selectedOpen;

      this.getEvents(this.calendarEventDate);
    },

    async houseFilterSelect() {
      this.getEvents(this.calendarEventDate);
      this.houseDialog = false;
    },

    async staffFilterSelect() {
      this.getEvents(this.calendarEventDate);
      this.staffDialog = false;
      /*
            const events = [];
            this.events = [];
            this.totalHoursSchedule = 0;

            axios
                .get(`${url}/shifts/staff`, {
                    params: {
                        EmployeeId: this.staffSelected,
                    },
                })
                .then((res) => {
                    res.data.shifts.forEach((item) => {
                        const {employee, units} = item;
                        events.push({
                            id: item._id,
                            start: moment(item.StartDate).format("YYYY-MM-DD HH:mm"),
                            end: moment(item.EndDate).format("YYYY-MM-DD HH:mm"),
                            color: units?.ShiftColor || this.colors[this.rnd(0, this.colors.length - 1)],
                            event: "Schedule",
                            name: employee?.Name || "",
                            notes: item.Notes,
                            staffId: item.employee,
                            houseId: item.HouseId,
                            clientId: item.ClientId,
                        });
                    });
                })
                .catch((err) => {
                    this.msg = true;
                    this.text = err.response.data.msg;
                    this.color = "red";
                })
                .finally(() => {
                    this.events = events;
                    this.staffDialog = false;

                    // Map how many hours per schedule
                    this.getHoursPerSchedule(this.calendarType, this.calendarEvent);
                }); */
    },

    async clientFilterSelect() {
      this.getEvents(this.calendarEventDate);
      this.clientDialog = false;
    },

    async getUserRolesPermission() {
      if (this.rolesToShowAllPrograms.includes(this.userRole)) {
        this.userRolesWithPrivilege.push(this.userRole);
        this.userRolesFilterProgram.push(this.userRole);
      }

      // await axios.get(`${url}/userRolePermission`).then((res) => {
      //     this.usersAllowedPermissionRoles = res.data.permission;
      //     console.log({allowedPermission: this.usersAllowedPermissionRoles});
      //
      //     this.usersAllowedPermissionRoles.map((allowedRoles) => {
      //       if (
      //         allowedRoles.Type === "Shift" &&
      //         allowedRoles.Description === "showAllProgram"
      //       ) {
      //         allowedRoles.AllowedRoles.forEach((role) => {
      //           this.userRolesWithPrivilege.push(role);
      //         });
      //       } else if (
      //         allowedRoles.Type === "Shift" &&
      //         allowedRoles.Description === "showFilterProgram"
      //       ) {
      //         allowedRoles.AllowedRoles.forEach((role) => {
      //           this.userRolesFilterProgram.push(role);
      //         });
      //       } else if (
      //         allowedRoles.Type === "Shift" &&
      //         allowedRoles.Description === "showAllStaff"
      //       ) {
      //         allowedRoles.AllowedRoles.forEach((role) => {
      //           this.staffFilterRoles.push(role);
      //         });
      //       }
      //     });
      //
      //   })
      //   .finally(() => (this.isLoading = false));
    },
    printCalendar() {
      let startDate = this.shiftStartDate;
      let endDate = this.shiftEndDate;
      let staff = this.staffSelected;

      let downloadUrl = `${url}/shifts/print?staffId=${staff}&startDate=${startDate}&endDate=${endDate}`;

      // Show the "Print in progress" modal
      Swal.fire({
        title: "Print in Progress",
        text: "Please wait while the PDF is being generated and processed. This may take a while.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make a request to the backend API to generate the PDF
      fetch(downloadUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            // Close the modal when the printing process is complete
            Swal.close();

            printWindow.print();

            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error("Error generating or printing the PDF:", error);
          Swal.fire("Error", "Failed to generate or print the PDF", "error");
        });
    },

    displayElemsOnStaff() {
      let staffs = ["Direct Care Staff", "Shift Lead"];

      return this.userRole.includes(staffs) ? false : true;
    },

    clearSearchData() {
      this.houseSelected = [];
      this.staffSelected = [];
      this.clientSelected = [];
      this.getEvents(this.calendarEventDate);
    },
  },
};
</script>
<style>
@media print {
  .fc-header-toolbar,
  .fc-license-message {
    display: none;
  }

  #calendar {
    width: 100%;
    height: auto;
  }
}

.fc .fc-toolbar {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  flex-wrap: wrap !important;
}

.fc-daygrid-event {
  font-size: 12px;
  font-weight: bold;
  text-shadow: 1px 1px 3px black;
}

@media (max-width: 959.98px) {
  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }
}
</style>

<style scoped>
.calendar-update-dialog-v-menu-content {
  left: 50% !important;
  transform: translateX(-50%) !important;
}

@media (max-width: 959.98px) {
  .order-1 {
    order: 1;
  }

  .order-2 {
    order: 2;
  }
}
</style>

<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}

.v-application {
  justify-content: center;
}

.btn-group--active.v-btn--active::before {
  opacity: 0 !important;
}

#speeddial .v-speed-dial {
  position: absolute;
}

#speeddial .v-btn--floating {
  position: relative;
}

.total-hours-schedule {
  position: relative;
  left: 8px;

  span {
    vertical-align: middle;
  }
}
</style>
